export const kioskActionTypes = {
    GET_KIOSKS_SUCCESS: 'GET_KIOSKS_SUCCESS',
    GET_KIOSKS_FAILURE: 'GET_KIOSKS_FAILURE'
};